import React from 'react';

import { trans, getResourcePath } from '@spotahome/soyuz/client';
import { IconWithText } from '@spotahome/ui-library';

const Benefits = () => (
  <div className="wrapper">
    <div className="three-cols">
      <div className="about-guarantee_item">
        <IconWithText
          title={trans('home-checker.benefit.flexibility')}
          content={trans('home-checker.benefit.flexibility.content')}
          iconUrl={getResourcePath('/images/icons/flexibility.svg')}
          theme="dark"
          contentFontStyle="normal"
        />
      </div>
      <div className="about-guarantee_item">
        <IconWithText
          title={trans('home-checker.benefit.extra-money')}
          content={trans('home-checker.benefit.extra-money.content')}
          iconUrl={getResourcePath('/images/icons/money.svg')}
          theme="dark"
          contentFontStyle="normal"
        />
      </div>
      <div className="about-guarantee_item">
        <IconWithText
          title={trans('home-checker.benefit.fun-joy')}
          content={trans('home-checker.benefit.fun-joy.content')}
          iconUrl={getResourcePath('/images/icons/fun-joy.svg')}
          theme="dark"
          contentFontStyle="normal"
        />
      </div>
    </div>
  </div>
);

export default Benefits;
